var shipping = {}; 

var checkCep = function(cthis) {
    shipping.current = $(cthis).closest(".shipping-calculator");
    shipping.cepval = shipping.current.find(".address_zip").val();
    shipping.current.find(".new-get-rates").addClass("get-rates")
    if(shipping.cepval.length != 9) {
        alert("Digite um CEP válido.")
    }else {
        addProdCart();
    }
}
var addProdCart = function() {
    var variantid = $("#variantid");
    if(variantid[0]) {
        var variantvalue = $("#variantid").val();
        var cartItens;

        jQuery.getJSON('/cart.js', function(cart) {
            cartItens = cart.item_count;
            if(cartItens == 0) {
                console.log("adicionando...")
                Shopify.addItem(variantvalue, 1, function(){
                    console.log('Success!!!')
                    carregaFrete(shipping.cepval);
                    $('.wrapper-response').html('');

                    function removeItemCart() {
                        if ($('#shipping-rates-feedback')[0] && $('#shipping-rates-feedback').hasClass('success')) {
                            Shopify.removeItem(variantvalue);
                            console.log("Cart clean");

                        } else {
                            setTimeout(function () {
                                removeItemCart();
                            }, 1000);
                        }
                    }
                    removeItemCart();
                });
            }else {
                console.log(cartItens + " - itens no carrinho")
                carregaFrete(shipping.cepval);
            } 
        });
    }else {
        carregaFrete(shipping.cepval);
    }
}
var carregaFrete = function() {
    debugger
    console.log("carrega frete");
    $(".get-rates-custom").addClass("loading");
    $("#shipping-calculator .loading").addClass("load");
    
    $.getJSON("//viacep.com.br/ws/" + shipping.cepval + "/json/?callback=?", function(dados) {
        if (!("erro" in dados)) {
           
            if(!shipping.current.find(".shipping-calculator")[0]) {
                
                shipping.current.find(".wrapper-response").attr("id", "wrapper-response");
                Shopify.Cart.ShippingCalculator.show( {
                    submitButton: "Calcular", 
                    submitButtonDisabled: "Calculando...",
                    moneyFormat: moneyformat
                });
                shipping.current.find(".shipping-calculator").addClass("shiping-loaded");
                /*setTimeout(() => {
                    shipping.current.find(".wrapper-response").removeAttr("id");
                }, 5000);*/
                var state;
                var uf = dados.uf.toUpperCase();
                switch (uf) {
                    case "AC" :	state = "Acre";					break;
                    case "AL" :	state = "Alagoas";				break;
                    case "AM" :	state = "Amazonas";				break;
                    case "AP" :	state = "Amapá";				break;
                    case "BA" :	state = "Bahia";				break;
                    case "CE" :	state = "Ceará";				break;
                    case "DF" :	state = "Distrito Federal";		break;
                    case "ES" :	state = "Espírito Santo";		break;
                    case "GO" :	state = "Goiás";				break;
                    case "MA" :	state = "Maranhão";				break;
                    case "MG" :	state = "Minas Gerais";			break;
                    case "MS" :	state = "Mato Grosso do Sul";	break;
                    case "MT" :	state = "Mato Grosso";			break;
                    case "PA" :	state = "Pará";					break;
                    case "PB" :	state = "Paraíba";				break;
                    case "PE" :	state = "Pernambuco";			break;
                    case "PI" :	state = "Piauí";				break;
                    case "PR" :	state = "Paraná";				break;
                    case "RJ" :	state = "Rio de Janeiro";		break;
                    case "RN" :	state = "Rio Grande do Norte";	break;
                    case "RO" :	state = "Rondônia";				break;
                    case "RR" :	state = "Roraima";				break;
                    case "RS" :	state = "Rio Grande do Sul";	break;
                    case "SC" :	state = "Santa Catarina";		break;
                    case "SE" :	state = "Sergipe";				break;
                    case "SP" :	state = "São Paulo";			break;
                    case "TO" :	state = "Tocantíns";			break;
                  }                  
                  var timerjQuery = setInterval( function() {
                    if($('[name="address[province]"] option')[0]) {
                        $('[name="address[province]"]').val(state); 
                        $('[name="address[province]"]').prop('selected', true);
                        shipping.current.find('.get-rates').trigger('click');
                        clearInterval( timerjQuery );
                    }
                  }, 1000);
            }


        } else {
            flag = false;
            alert("CEP não encontrado");
        }
        $(".get-rates-custom").removeClass("loading");
        
    }).fail(function(jqXHR) {
        alert("Consulta de CEP indisponível no momento")
    });    
}

const initShipping = () => {
    $(document).on('click', '.get-rates-custom', function() {
        console.log("clicou");
        checkCep($(this));
    });

    $(document).on('keypress', '#address_zip', function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
            checkCep($(this));
        }
    });
}

const intervalInit = setInterval(() => {
    if (typeof $ == 'function') {
        clearInterval(intervalInit);
        initShipping();
    }
}, 500);

// ---------------------------------------------------------
// Este é um arquivo opcional, usado somente para temas que não tenha os métodos addItem e removeItem
// ---------------------------------------------------------


// ---------------------------------------------------------
// POST to cart/add.js returns the cart in JSON.
// ---------------------------------------------------------
if ((typeof Shopify) === 'undefined') {
    Shopify = {};
}

Shopify.addItem = function (variant_id, quantity, callback, attr, name_product) {

    var quantity = quantity || 0;
    if (typeof attr == 'undefined') {
        attr = [];
    }
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: quantity, id: variant_id, properties: attr },
        dataType: 'json',
        success: function (line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                jQuery.get('/cart?view=json', function (data) {
                    /*optional stuff to do after success */
                    jQuery('.cart-flyout').html(data);
                    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                });
                jQuery.getJSON('/cart.js', function (cart) {
                    jQuery(".la-cart-count").html(cart.item_count);
                });
                //remove_ajaxcart
                //jQuery('body').addClass('open-cart-aside');
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = function (variant_id, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        beforeSend: function () {
            jQuery(".cart-flyout").addClass('removing-process');
        },
        data: 'quantity=0&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            }
            else {
                jQuery.get('/cart?view=json', function (data) {
                    /*optional stuff to do after success */
                    jQuery('.cart-flyout').html(data);
                    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                });
                jQuery.getJSON('/cart.js', function (cart) {
                    jQuery(".la-cart-count").html(cart.item_count);
                });
            }
        },
        complete: function () {
            jQuery(".cart-flyout").removeClass('removing-process');
        },
        error: function (XMLHttpRequest, textStatus) {
            jQuery(".cart-flyout").removeClass('removing-process');
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};  